<template>

<div>

  <LDBsTable
    url="commandtypes"
    defaultSort="idCommand"
    defaultOrder="asc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-6">
      <label>{{ $t('idCommand') }}</label>
      <input 
        type="text"
        class="form-control"
        id="idCommand"
        name="idCommand"
        :placeholder="$t('ph_idCommand')"
        v-model="query.idCommand"
      >
    </div>

    <div class="form-group col-6">
      <label>{{ $t('description') }}</label>
      <input 
        type="text"
        class="form-control"
        id="description"
        name="description"
        :placeholder="$t('ph_description')"
        v-model="query.description"
      >
    </div>
  </LDBsTable>

</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'

export default {
  name: 'CommandTypesList',
  components: {
    LDBsTable
  },
  data () {
    return {
      columns: [
        {
          title: 'ID',
          field: 'id',
          width: '100%'
        },
        {
          title: this.$t('idCommand'),
          field: 'idCommand',
          sortable: true
        },
        {
          title: this.$t('description'),
          field: 'description',
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/commandtype/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'tipos_de_comando' }
      },
      query: {
        id: '',
        idCommand: undefined,
        description: ''
      }
    }
  },
  methods: {
    clear() {
      this.query.description = ''
      this.query.idCommand = undefined
    }
  }
}

</script>